export default "__VITE_ASSET__DU_$axhD__"